import { LogoIcon } from '../../assets/icons';
import styles from './pagewrapper.module.css';

interface IPageWrapperProps {
    title: string;
    subText: string;
    children: React.ReactNode;
}

export function PageWrapper({ title, subText, children }: IPageWrapperProps) {
    const url = process.env.REACT_APP_BASE_URL;

    return (
        <section className={styles.pageWrapper}>
            <div className={styles.wrapperContent}>
                <div className={styles.wrapperHeader}>
                    <a href={url} className={styles.logo}><LogoIcon />РОКС</a>
                    <div className={styles.textBlock}>
                        <h2 className={styles.title}>{title}</h2>
                        <p className={styles.subText}>{subText}</p>
                    </div>
                </div>
                {children}
            </div>
        </section>
    )
}
